<template>
  <div>
    <v-subheader class="title-setting">Facturación</v-subheader>

    <v-form v-on:submit.prevent="save">
      <div class="col-md-12">
        <div class="col-md-12">
          <p class="title_bi">Nuevo Comprobante</p>
          <v-checkbox label="Precargar el comprobante anterior al seleccionar un receptor" v-model="mainItem.preload_last_voucher"></v-checkbox>

          <v-checkbox label="Al enviar un nuevo email, reutilizar asunto y mensaje del último email enviado al cliente" v-model="mainItem.config_email"></v-checkbox>

          <v-checkbox label="Permitir IVA en Facturas X" v-model="mainItem.allow_iva_voucher_x"></v-checkbox>

        </div>

        <div class="col-md-12 mt-4">
          <p class="title_bi">Configuración de Impresión</p>
          <v-checkbox label="Ocultar logo de la empresa en comprobantes que no son de ARCA" v-model="mainItem.hide_logo_non_afip"></v-checkbox>

          <v-textarea
            label="Leyenda para todos los comprobantes de facturación"
            v-model="mainItem.billing_legend"
            outlined
            dense
            rows="3"
            hint="Esta leyenda se mostrará en todos los comprobantes impresos"
            persistent-hint
          ></v-textarea>
        </div>

        <div class="col-md-12 mt-4 text-right">
          <v-btn color="green darken-1" text :loading="loading" type="submit"> Guardar </v-btn>
        </div>
      </div>
    </v-form>
  </div>
</template>

<script>
export default {
  props: {
    mainItem: Object,
    createItem: Function,
    loading: Boolean,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    save(e) {
      this.$emit("createItem", e);
    },
  },
};
</script>
